<dx-file-uploader class="border-files" #fileUploader *ngIf="canUpload" [disabled]="disabled" (onValueChanged)="onFileAdded($event)" (onUploaded)="onUploaded($event)" [uploadMode]="'useButtons'" [accept]="accepts"></dx-file-uploader>

<hr>

<div *ngIf="showPreview" class="container">
    <div class="row mb-2">
        <div class="col-xl-2 col-lg-4 col-sm-6 col-xs-12 text-center" *ngFor="let image of images">
            <!-- <input type="checkbox" text="Glavna" (onValueChanged)="validateMain(image)" [(value)]="image.isMain" ></dx-check-box> -->
            <mat-checkbox *ngIf="!single && image" [checked]="image?.isMain" 
            (change)="validateMain(image)">
                {{ 'SHARED.MAIN' | translate }} 
            </mat-checkbox>
            <img class="img-responsive d-inline p-1" height="150px" src="{{ bucketBaseUrl }}{{ image?.path || images }}" alt="{{ image?.path || images }}">
            <dx-button *ngIf="canDelete && image" class="navbar-button mt-1" [height]="32" stylingMode="contained" icon="trash" [text]="'SHARED.DELETE' | translate" type="danger" (onClick)="deleteImage(image)"></dx-button>
        </div>
    </div>
</div>


<!-- <dx-data-grid #filesGrid [dataSource]="files" [rowAlternationEnabled]="true" [showBorders]="true" [showRowLines]="true" [showColumnLines]="true">
    <dxo-editing mode="single" [allowAdding]="canUpload" [allowUpdating]="canUpload" [allowDeleting]="canUpload"></dxo-editing>

    <dxi-column dataField="key" [allowFiltering]="true" [allowSorting]="true" [caption]="'COMPANIES.CONFIGURATION' | translate" >
        <dxo-lookup [dataSource]="configurationKeys" [valueExpr]="'value'" [displayExpr]="'label'"></dxo-lookup>
        <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
        <dxi-validation-rule type="custom" [message]="'VALIDATION.UNIQUE' | translate"></dxi-validation-rule>
    </dxi-column>

</dx-data-grid> -->

<!-- 
<dx-popup width="500px" maxWidth="80%" height="210px" maxHeight="80%" [(visible)]="isNameModalVisible" [title]="'SHARED.NAME' | translate" (onHiding)="closeNameModal()">
    <div class="dx-fieldset">
        <div class="dx-field">
            <div class="dx-field-label">{{ 'SHARED.NAME' | translate}}</div>
            <div class="dx-field-value">
                <dx-text-box [(value)]="name"></dx-text-box>
            </div>
        </div>
    </div>
    <hr>
    <div class="dx-popup-footer">
        <div class="row col-sm-8 offset-sm-2">
            <div class="col-sm">
                <button type="button" (click)="saveName()" class="btn btn-success btn-block"
                    [disabled]="name == null || name == ''">
                    <i class="fa fa-copy"></i> {{ 'SHARED.SAVE_CHANGES' | translate }}
                </button>
            </div>
            <div class="col-sm">
                <button type="button" (click)="closeNameModal()"
                    class="btn btn-light btn-block">{{ 'SHARED.CLOSE' | translate }}</button>
            </div>
        </div>
    </div>
</dx-popup> -->
